/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $Container, getProp, ExtendContainerProps, $GraphicsBox, mapProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {ResponsiveConf} from '@gongxigames/framework/core/fragments/display/responsive';
import {$PopupBg} from './PopupBg';
import {$Button} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Button';
import {$PopupHeader} from './PopupHeader';
import {Rectangle} from 'pixi.js';
import {getDefaultPopupSize} from './etc';

const CLOSE_BTN_HIT_AREA = new Rectangle(-38/2, -38/2, 38, 38);

export type PopupProps = ExtendContainerProps<{
    headerId?: string;
    headerMaxWidth?: number;
    responsiveConfig?: ResponsiveConf;
    onClose?: () => void;
    show: boolean;
    faderAlpha?: number;
}>;

export const $Popup: FC<PopupProps> = (props) => {
    const boxAlpha = mapProp(props.faderAlpha, alpha => alpha ?? 0.6);
    const name = mapProp(props.headerId, headerId => headerId ? `popup:${headerId}`: 'popup');
    const responsiveConfig = props.responsiveConfig ?? getDefaultPopupSize();
    const heder = mapProp(props.headerId, headerId => {
        const maxWidth = getProp(props.headerMaxWidth);

        return headerId ? <$PopupHeader headerId={headerId} headerMaxWidth={maxWidth}/>: undefined;
    });

    return <$Container
        {...props}
        name={name}
        visible={props.show}
    >
        <$GraphicsBox
            responsiveBoxSize
            responsive={{
                box: {width: '100%', height: '100%'}
            }}
            boxColor={0x010101}
            boxAlpha={boxAlpha}
            interactive={true}
            events={{
                pointertap: () => getProp(props.onClose)?.(),
                pointerdown: () => {},
                pointerup: () => {},
            }}
        />
        <$PopupBg responsive={responsiveConfig} interactive={true}>
            {heder}
            <$Button
                hitArea={CLOSE_BTN_HIT_AREA}
                name='x_btn'
                action={props.onClose}
                responsive={{
                    box: {x: '100%'},
                    translate: {x: '-58px', y: '58px'}
                }}
            />
            {props.children}
        </$PopupBg>
    </$Container>;
};